import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/site")({
  head: () => ({ meta: [{ title: "Site Settings | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-site")),
});
